export const PrintAbstractState = {
	url: '/print',
	abstract: true,
	redirectTo: 'print.proposal', // default child
	template: '<print-abstract-page></print-abstract-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "printAbstractPageMod" */
			'@Containers/print-abstract-page/print-abstract-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
